import DeepLinkProjection from '@/types/projections/DeepLinkProjection';

export const buildDeepLinkObject = (url: URL): DeepLinkProjection | undefined => {
  const communeId = url.searchParams.get('communeId');
  const id = url.searchParams.get('id');
  const identificationNr = url.searchParams.get('identificationNr');
  const name = url.searchParams.get('name');
  const addressStreetAndNumber = url.searchParams.get('addressStreetAndNumber');
  const addressZip = url.searchParams.get('addressZip');
  const addressCity = url.searchParams.get('addressCity');
  const active = url.searchParams.get('active') === 'true' || url.searchParams.get('active') === null;
  
  // Optional Fields
  const guestSalutation = url.searchParams.get('guestSalutation');
  const guestFirstName = url.searchParams.get('guestFirstName');
  const guestLastName = url.searchParams.get('guestLastName');
  const guestArrivalDate = url.searchParams.get('guestArrivalDate');
  const guestDepartureDate = url.searchParams.get('guestDepartureDate');
  const guestBirthdate = url.searchParams.get('guestBirthdate');
  const guestBirthdateDay = url.searchParams.get('guestBirthdateDay');
  const guestBirthdateMonth = url.searchParams.get('guestBirthdateMonth');
  const guestBirthdateYear = url.searchParams.get('guestBirthdateYear');
  const guestStreetAndNumber = url.searchParams.get('guestStreetAndNumber');
  const guestCity = url.searchParams.get('guestCity');
  const guestPostCode = url.searchParams.get('guestPostCode');
  const guestEmail = url.searchParams.get('guestEmail');
  const guestCellphoneNumber = url.searchParams.get('guestCellphoneNumber');

  const guestAProvidersBookingNo = url.searchParams.get('guestAProvidersBookingNo');

  if (
    !communeId ||
    !id ||
    !identificationNr ||
    !name ||
    !addressStreetAndNumber ||
    !addressZip ||
    !addressCity ||
    !active
  ) {
    return;
  }

  return {
    id: parseInt(id, 10),
    identificationNr,
    name,
    addressStreetAndNumber,
    addressZip,
    addressCity,
    communeId: parseInt(communeId, 10),
    active,
    guestSalutation: guestSalutation ? parseInt(guestSalutation, 10) : null,
    guestFirstName,
    guestLastName,
    guestArrivalDate,
    guestDepartureDate,
    guestBirthdate,
    guestBirthdateDay: guestBirthdateDay ? parseInt(guestBirthdateDay, 10) : null,
    guestBirthdateMonth: guestBirthdateMonth ? parseInt(guestBirthdateMonth, 10) : null,
    guestBirthdateYear: guestBirthdateYear ? parseInt(guestBirthdateYear, 10) : null,
    guestStreetAndNumber,
    guestCity,
    guestPostCode: guestPostCode ? parseInt(guestPostCode, 10) : null,
    guestEmail,
    guestCellphoneNumber,
    guestAProvidersBookingNo
  };
};

export default {
  buildDeepLinkObject,
};
